import * as React from 'react';
import { SVGProps } from 'react';

const IconQuestionSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM10.131 9.143H7.714c0-2.572 1.833-4.286 4.572-4.286 2.55 0 4.285 1.637 4.285 3.857 0 1.442-.6 2.488-1.857 3.286-1.186.74-1.657 1.067-1.657 1.99l.072.867H10.77l-.1-.886c-.115-1.538.527-2.335 1.758-3.114 1.15-.74 1.428-1.106 1.428-2 0-.992-.726-1.693-1.857-1.693s-1.815.921-1.869 1.979zm3.452 8.639c0 1.01-.615 1.634-1.614 1.634-1 0-1.623-.625-1.623-1.634 0-1.02.624-1.644 1.623-1.644s1.614.625 1.614 1.644z"
    />
  </svg>
);
export default IconQuestionSizeM;
